import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../hooks/useAuth";
import { registerUser, verifyRegistrationEmail, logoutUser, loginUser, sendPasswordResetEmail, resetPassword, changePassword, changeName } from "../services/api";


export const useChangeName = (onSuccessCallback) => {
    const { storeAuthData, clearAuthData } = useAuth();
    return useMutation({
        mutationFn: changeName,
        onSuccess: (data) => {
            storeAuthData(data);
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        },
    });
};

export const useRegisterUser = () => {
    return useMutation({
        mutationFn: registerUser,

        onMutate: async (variables) => {
            // Optionally cancel ongoing queries or save the previous state
        },
        onSuccess: (data, variables, context) => {
            // Handle success, update UI, show success message, etc.
        },
        onError: (error, variables, context) => {
            // Handle error, show error message, etc.
        },
        onSettled: (data, error, variables, context) => {
            // Handle cleanup actions, like hiding loading spinners
        },
    });
};

export const useVerifyRegistrationEmail = ({ onSuccess, onFailure }) => {
    const { storeAuthData, clearAuthData } = useAuth();

    return useMutation({
        mutationFn: verifyRegistrationEmail,
        onMutate: (data) => {
            clearAuthData();
        },
        onSuccess: (data) => {
            storeAuthData(data);
            if (onSuccess) onSuccess(data);

        },
        onError: (error) => {
            if (onFailure) onFailure(error);
        }
    });
};


export const useLogoutUser = () => {
    const { clearAuthData } = useAuth();
    return useMutation({
        mutationFn: logoutUser,
        onSuccess: () => {
            clearAuthData();
            // Navigate and reload
            window.location.replace("/");
        },
        onError: (error) => {
            clearAuthData();
            // Navigate and reload
            window.location.replace("/");
        },
        onSettled: () => {
            clearAuthData();
            // Navigate and reload
            window.location.replace("/");
        }
    });
};

export const useLoginUser = () => {
    const { storeAuthData } = useAuth();
    return useMutation({
        mutationFn: loginUser,
        onSuccess: (data) => {
            storeAuthData(data);
        },
    });
};

export const useSendPasswordResetEmail = () => {
    return useMutation({
        mutationFn: sendPasswordResetEmail,
    });
};

export const useResetPassword = ({ onSuccess, onFailure }) => {
    const { storeAuthData } = useAuth();
    return useMutation({
        mutationFn: resetPassword,
        onSuccess: (data) => {
            storeAuthData(data);
            if (onSuccess) onSuccess();
        },
        onError: (error) => {
            if (onFailure) onFailure(error);
        }
    });
};

export const useChangePassword = (onSuccessCallback) => {
    const { storeAuthData } = useAuth();
    return useMutation({
        mutationFn: changePassword,
        onSuccess: (data) => {
            storeAuthData(data);
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        },
    });
};
